/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import dayjs from 'dayjs'

const entity = {
  longId: {
    displayName: 'voucherCode'
  },
  totalAmount: {
    displayName: 'CashAmount',
    type: IKDataEntity.Types.Float
  },
  leftAmount: {
    displayName: 'Credit',
    type: IKDataEntity.Types.Float
  },
  createdAt: {
    type: IKDataEntity.Types.Date
  },
  editVoucherCode: {
    displayName: 'edit',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }

}
const config = {
  load: async function (filter) {
    console.log(filter, 'filter')
    if (filter[0].showAll) {
      return (await hillo.get('MemberCard.php', {
        op: 'showAllMemberCardSaleRecord'
      })).content
    } else {
      const [fromDate, toDate] = filter[0].dateFilter
      return (await hillo.get('MemberCard.php', {
        op: 'showAllMemberCardSaleRecord'
      })).content.filter(item => {
        return dayjs(item.createdAt).isAfter(dayjs(fromDate)) && dayjs(item.createdAt).isBefore(dayjs(toDate).add(1, 'day'))
      })
    }
  }
}

export async function getCouponRecord (id) {
  return (await hillo.get('MemberCard.php', {
    op: 'getOne',
    withConsumeLog: true,
    id
  })).content
}

export async function editVoucherCode (oldLongId, newLongId) {
  return (await hillo.post('MemberCard.php?op=renameMemberCard', {
    old: oldLongId,
    new: newLongId
  })).content
}

export default IKDataEntity.ModelFactory(entity, config)
